module.exports = __webpack_public_path__ + "static/img/barra_14.2ac3151.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/barra_14.png
// module id = T6hk
// module chunks = 1